import { cn, getPreviewAspectClass } from "@/lib/utils";

interface EmptyStateProps {
  aspectRatio: string;
}

export function EmptyState({ aspectRatio }: EmptyStateProps) {
  return (
    <div className={cn("live-preview-frame w-full mx-auto shadow-2xl", getPreviewAspectClass(aspectRatio))}>
      <div className="stage-fallback animate-in fade-in duration-700">
        <div className="stage-vignette" />
        <div className="stage-safe-frame" />
        <div className="stage-text-wrap">
          <div className="stage-text-roll is-placeholder opacity-40">
            A quiet frame.<br />
            A line in motion.<br />
            A final image that lingers.
          </div>
        </div>
      </div>
    </div>
  );
}
